import { FlexibleInputCalendar, FlexibleInputCalendarProps } from './FlexibleInputCalendar';
import { StructuredInputCalendar, StructuredInputCalendarProps } from './StructuredInputCalendar';

export type CalendarWithDateTimeFieldsProps = StructuredInputCalendarProps | FlexibleInputCalendarProps;

export const CalendarWithDateTimeFields = (props: CalendarWithDateTimeFieldsProps) => {
  const inputMode = props.inputMode ?? 'structured';

  if (inputMode === 'flexible') {
    return <FlexibleInputCalendar {...(props as FlexibleInputCalendarProps)} />;
  }

  return <StructuredInputCalendar {...(props as StructuredInputCalendarProps)} />;
};
